import React, { useEffect, useRef, useState } from "react";
import PropTypes from "prop-types";
import moment from "moment";
import { useTranslation } from "react-i18next";

import { AdapterMoment } from "@mui/x-date-pickers/AdapterMoment";
import { TimePicker, LocalizationProvider } from "@mui/x-date-pickers";

import { generateKey, isFunction } from "../../utils";

const CompTimePickerNew = (props) => {
  const { t } = useTranslation("translation");
  const key = generateKey("timepicker");
  const {
    label,
    isLabelShrink,
    error,
    value = null,
    id,
    disabled,
    onChange,
    className,
    ...componentProps
  } = props;

  const format = "HH:mm:ss";
  const container = React.createRef();

  const [selectedTime, setSelectedTime] = useState(
    value ? moment.utc(value) : null
  );
  const [errorText, setErrorText] = useState(error);

  const mounted = useRef(false);
  useEffect(() => {
    if (!mounted.current) {
      mounted.current = true;
    } else {
      const currentGivenValue = value ? moment.utc(value) : null;
      if (
        currentGivenValue &&
        !currentGivenValue.isSame(moment.utc(selectedTime))
      ) {
        setSelectedTime(currentGivenValue);
      }
    }
  }, [value]);

  const handleChange = (newValue) => {
    setSelectedTime(newValue);

    if (!newValue || !moment(newValue).isValid()) {
      setErrorText(t("errors.invalid_value"));
      return;
    }
    setErrorText(null);

    if (isFunction(onChange)) {
      const data = {
        target: {
          ...componentProps,
          value: moment(newValue).set("second", 0).format(format),
          id: key,
        },
      };
      onChange(data);
    }
  };

  return (
    <div
      id={`comp-timepicker-container-${key}`}
      className={`comp-timepicker-container ${
        className ? "container-" + className : ""
      } ${error ? "error" : ""} ${disabled ? "disabled" : ""}`}
      ref={container}
    >
      <LocalizationProvider dateAdapter={AdapterMoment}>
        <TimePicker
          {...componentProps}
          label={label}
          value={selectedTime}
          onChange={handleChange}
          disabled={disabled}
          ampm={false}
          slotProps={{
            textField: {
              fullWidth: true,
              error: Boolean(error),
              helperText: error ? t("errors." + error) : "",
              InputLabelProps: { shrink: isLabelShrink },
                sx: {
                  backgroundColor: "white",
                    "& .MuiInputBase-root": {
                        height: 39,
                    },
                    "& .MuiInputBase-input": {
                        height: "100%",
                        padding: "0 14px",
                        boxSizing: "border-box",
                    },
                    "& .MuiOutlinedInput-notchedOutline": {
                        borderColor: "#404CE2"
                    },
                    "&:hover .MuiOutlinedInput-notchedOutline": {
                        borderColor: '#007FFF'
                    }
                },
            },
          }}
        />
      </LocalizationProvider>
    </div>
  );
};

CompTimePickerNew.propTypes = {
  label: PropTypes.string,
  error: PropTypes.string,
  value: PropTypes.any,
  onChange: PropTypes.func,
  isLabelShrink: PropTypes.bool,
  disabled: PropTypes.bool,
  className: PropTypes.string,
};

export { CompTimePickerNew };